<template>
  <div class="lby-sort-tool" ref="sortToolOuter">
    <div class="lby-sort-tool-row1">
        <div class="lby-sort-item"  @click="sortPrice">
        <div class="lby-sort-tag">
            价格
        </div>
        <div>
            <div class="triangle-up" :style="{'border-bottom-color':this.queryValue.orderByPrice===1?'red':'white'}"></div>
            <div class="triangle-down" :style="{'border-top-color':this.queryValue.orderByPrice===2?'red':'white'}"></div>
        </div>
    </div>
    <div class="lby-sort-item" @click="sortFightNumber">
        <div class="lby-sort-tag">
            战斗力
        </div>
        <div>
            <div class="triangle-up" :style="{'border-bottom-color':this.queryValue.orderByFightNumber===1?'red':'white'}"></div>
            <div class="triangle-down" :style="{'border-top-color':this.queryValue.orderByFightNumber===2?'red':'white'}"></div>
        </div>
    </div>
    <div class="lby-sort-item" @click="sortAttributeScore">
        <div class="lby-sort-tag">
            属性评分
        </div>
        <div>
            <div class="triangle-up" :style="{'border-bottom-color':this.queryValue.orderByAttributeScore===1?'red':'white'}"></div>
            <div class="triangle-down"  :style="{'border-top-color':this.queryValue.orderByAttributeScore===2?'red':'white'}"></div>
        </div>
    </div>
    <div class="lby-sort-tool-price">
        <span>价格:</span>
        <input v-model="queryValue.minPrice" placeholder="最低价格￥"/>
        <input v-model="queryValue.maxPrice" placeholder="最大价格￥"/>
    </div>
    <div class="lby-sort-tool-profession">
        <span>职业:</span>
        <el-select v-model="queryValue.profession" filterable placeholder="职业" size="mini">
                <el-option
                v-for="item in $profession"
                :key="item.id"
                :label="item.type"
                :value="item.id"
                >
                </el-option>
        </el-select>
    </div>
    <div class="lby-sort-tool-search">
        <span>商品ID:</span>
        <input placeholder="请输入商品ID" v-model="queryValue.goodsId" style="width: 100px;"/>
        <button @click="searchGoods">搜索</button>
    </div>
    <div @click="showHideRow(false)" ref="moreBtn" class="more-btn">
      选项+
    </div>
    </div>
    <div class="lby-sort-tool-row2" v-if="showRow3">
        <div class="lby-sort-tool-server">
            <span>起始日期:</span>
            <div class="lby-select-outer">
              <el-date-picker
                v-model="queryValue.startDate"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期" size="mini">
              </el-date-picker>
            </div>
        </div>
        <div class="lby-sort-tool-server">
            <span>结束日期:</span>
            <div class="lby-select-outer">
              <el-date-picker
                v-model="queryValue.endDate"
                type="date"
                value-format="yyyy-MM-dd [23:59:59]"
                placeholder="选择日期" size="mini">
              </el-date-picker>
            </div>
        </div>
        <div class="lby-sort-tool-equip">
            <span>人物属性:</span>
            <input placeholder="最小值(亿)" v-model="queryValue.minAttributeScore"/>
            <input placeholder="最大值(亿)" v-model="queryValue.maxAttributeScore"/>
        </div>
    </div>
    <div class="lby-sort-tool-row2">
        <div class="lby-sort-tool-server">
            <span>所在大区:</span>
            <div class="lby-select-outer">
            <el-select clearable v-model="queryValue.regionId" filterable placeholder="请选择大区" size="mini" @change="handleRegionChange">
                <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                >
                </el-option>
            </el-select>
            </div>
        </div>
        <div class="lby-sort-tool-server">
            <span>所在小区:</span>
            <div class="lby-select-outer">
                <el-select v-model="queryValue.serverId" filterable placeholder="请选择小区" size="mini">
                <el-option
                v-for="item in serverList"
                :key="item.id"
                :label="item.serverName"
                :value="item.id">
                </el-option>
                </el-select>
            </div>
        </div>
        <div class="lby-sort-tool-equip">
            <span>装备元素值:</span>
            <input placeholder="最小值" v-model="queryValue.minEquipmentAttribute"/>
            <input placeholder="最大值" v-model="queryValue.maxEquipmentAttribute"/>
        </div>
        <div class="lby-sort-tool-equip">
            <span>装备神佑:</span>
            <input placeholder="神佑等级" v-model="queryValue.equipmentBless"/>
        </div>
        <div class="lby-sort-tool-equip" style="margin-top: 0px;">
          <label for="primitive">荒古套:</label>
          <input style="width: 22px;height: 22px;transform: translateY(5px);" v-model="queryValue.primitive" type="checkbox" class="lby-input-checkbox" id="primitive"/>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SortTool',
  props: {},
  data () {
    return {
      showRow3: false,
      queryValue: {
        orderByPrice: 0,
        orderByFightNumber: 0,
        orderByAttributeScore: 0,
        maxPrice: null,
        minPrice: null,
        goodsId: null,
        regionId: null,
        serverId: null,
        maxEquipmentAttribute: null,
        minEquipmentAttribute: null,
        equipmentBless: null,
        primitive: false,
        profession: null,
        pageNo: 1,
        startDate: null,
        endDate: null,
        minAttributeScore: null,
        maxAttributeScore: null
      }
    }
  },
  methods: {
    showHideRow (reload) {
      if (!reload) {
        this.showRow3 = !this.showRow3
      }
      if (this.showRow3) {
        this.$refs.sortToolOuter.style.height = '140px'
        this.$store.commit('sortdatas/setIsRowShow', true)
      } else {
        this.$store.commit('sortdatas/setIsRowShow', false)

        this.$refs.sortToolOuter.style.height = '90px'
        this.storedQueryValue = this.$store.state.sortdatas.goodsSort
        if (this.storedQueryValue == null) {
          this.queryValue.startDate = null
          this.queryValue.endDate = null
          this.queryValue.minAttributeScore = null
          this.queryValue.maxAttributeScore = null
        } else {
          this.storedQueryValue.startDate = null
          this.storedQueryValue.endDate = null
          this.storedQueryValue.minAttributeScore = null
          this.storedQueryValue.maxAttributeScore = null
          this.$store.commit('sortdatas/setGoodsSort', this.storedQueryValue)
        }
      }
    },
    handleRegionChange () {
      this.queryValue.serverId = null
    },
    sortPrice () {
      if (this.queryValue.orderByPrice === 0) {
        this.queryValue.orderByPrice = 1
      } else if (this.queryValue.orderByPrice === 1) {
        this.queryValue.orderByPrice = 2
      } else {
        this.queryValue.orderByPrice = 0
      }
    },
    sortFightNumber () {
      if (this.queryValue.orderByFightNumber === 0) {
        this.queryValue.orderByFightNumber = 1
      } else if (this.queryValue.orderByFightNumber === 1) {
        this.queryValue.orderByFightNumber = 2
      } else {
        this.queryValue.orderByFightNumber = 0
      }
    },
    sortAttributeScore () {
      if (this.queryValue.orderByAttributeScore === 0) {
        this.queryValue.orderByAttributeScore = 1
      } else if (this.queryValue.orderByAttributeScore === 1) {
        this.queryValue.orderByAttributeScore = 2
      } else {
        this.queryValue.orderByAttributeScore = 0
      }
    },
    searchGoods () {
      // 这里面要调用api发送搜索请求，并且将结果通过this.$emit传递给父组件中
      this.$store.commit('sortdatas/setGoodsSort', this.queryValue)
      this.$store.commit('pagehistory/setIndexPageNo', 1)
      this.$emit('searchClick', this.queryValue)
    }
  },
  computed: {
    serverList () { return this.$store.getters['basicdata/serverList'](this.queryValue.regionId) },
    regionList () { return this.$store.state.basicdata.regionList }
  },
  created () {
    if (this.$store.state.sortdatas.isRowShow !== null) {
      this.showRow3 = this.$store.state.sortdatas.isRowShow
    }
    if (this.$store.state.sortdatas.goodsSort !== null) {
      this.queryValue = this.$store.state.sortdatas.goodsSort
    }
    this.$emit('searchClick', this.queryValue)
  },
  mounted () {
    this.showHideRow(true)
  }
}
</script>

<style scoped lang="less">
.more-btn{
  position: absolute;
  right: 12px;
  cursor: pointer;
  color: rgb(63, 63, 63);
  font-size: 13px;
  line-height: 45px;
  transform: scale(0.9);
}
.more-btn:hover{
  color: rgb(6, 81, 243);
}
.lby-sort-tool{
    width: 1080px;
    border-radius: 10px;
    height: 90px;
    background: linear-gradient(to right, #312951, #2d7897, #8e56a2,#d9edf2);
    margin: 0 auto;
    display: flex;
    color: white;
    font-size: 15px;
    position: -webkit-sticky;
    position: sticky;
    top:0px;
    box-sizing: border-box;
    flex-direction: column;
    z-index: 999;
    .lby-sort-tool-row1,.lby-sort-tool-row2{
        width: 100%;
        height: 45px;
        position: relative;
        display: flex;
        border-bottom: 2px solid white;
    }
    .lby-sort-tool-row1{
        .lby-sort-tool-price{
        position: absolute;
        left: 320px;
        top:6px;
        input{
            width:100px;
            margin-left: 10px;
            }
        }
        .lby-sort-tool-profession{
          position: absolute;
          left: 610px;
          top:6px;
          /deep/.el-input {
            margin-left: 10px;
            width: 100px;
          }
        }

    }
    .lby-sort-tool-row2{
        border-bottom:none;
        .lby-sort-tool-server{
            display: flex;
            margin-left: 8px;
            align-items: center;
            .lby-select-outer{
                padding-left: 5px;
                width: 140px;
                height: 30px;
                /deep/.el-date-editor{
                    width: 140px;
                }
            }
        }
        .lby-sort-tool-equip{
            margin-top:6px;
            margin-left: 8px;
            input{
            width:100px;
            margin-left: 11px;
            }
            .lby-input-checkbox{
              width: 30px;
              margin-top: 5px;
            }
            label{
              margin-top: 5px;
            }
        }
    }
    .lby-sort-tool-search{
        position: absolute;
        right: 50px;
        top:6px;
        span,input{
            margin-left: 10px;
        }
        button{
            margin-left: 15px;
            width: 80px;
            height: 25px;
            border: none;
            border-radius: 3px;
            background-color:rgb(14, 93, 161);
            color:white;
        }
        button:hover{
            background-color: rgb(40, 132, 212);
        }
    }

    .lby-sort-item{
        padding-top: 12px;
        display: flex;
        width: 100px;
        justify-content: center;
        border-right: 2px solid white;
        cursor: pointer;
        .lby-sort-tag{
            margin-right: 10px;
        }
        div{
            .triangle-up {
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-bottom: 8px solid #ffffff; /* 向下三角形 */
            }

            .triangle-down {
                margin-top: 2px;
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 8px solid #ffffff; /* 向上三角形 */
            }
        }
    }
}

</style>
